import { IAnalyticsContext } from '@sennder/senn-node-microfrontend-interfaces'
import { AnalyticsProvider } from '@sennder/shell-utilities'

import { logger } from '@/services/logger/loggers'
import { sendErrorInMonitor } from '@/services/monitor'

/**
 * This is a temporary solution to fix the event prefix name issue.
 * Ideally each microfrontend should not define the prefix name, but should be defined in the shell.
 */
export const getTrackEventName = (name: string): string => {
  // If events came from orcas
  if (name.startsWith('orcas/')) {
    return name.replace('orcas/', 'tms/')
  }

  // If events came from octopus
  if (name.startsWith('octopus/')) {
    return name.replace('octopus/', 'tms/')
  }

  // If events has no prefix
  if (!name.startsWith('tms/')) {
    return `tms/${name}`.replace(/\/\//g, '/')
  }

  return name
}

export class AppAnalyticsProvider extends AnalyticsProvider {
  constructor(context: IAnalyticsContext) {
    super({
      context,
      logger,
      messageSource: 'tms',
      formatEventName: getTrackEventName,
    })
  }
}

export const analytics = new AppAnalyticsProvider({
  module: 'tms-shell',
  submodule: '',
})

export function wrapWithDeprecationWarning(
  provider: AppAnalyticsProvider
): AppAnalyticsProvider {
  return {
    trackEvent(name, properties) {
      sendErrorInMonitor(new Error('[segment] trackEvent is deprecated'), {
        name,
        properties,
      })
      provider.trackEvent(name, properties)
    },
    trackPage(page, properties) {
      sendErrorInMonitor(new Error('[segment] trackPage is deprecated'), {
        page,
        properties,
      })
      provider.trackPage(page, properties)
    },
    forceTrackPageEvent() {
      sendErrorInMonitor(
        new Error('[segment] forceTrackPageEvent is deprecated')
      )
      provider.forceTrackPageEvent()
    },
    setContext(context) {
      sendErrorInMonitor(new Error('[segment] setContext is deprecated'), {
        context,
      })
      provider.setContext(context)
    },
  } as AppAnalyticsProvider
}
